"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core = {
    ensureNekotonLoaded: undefined,
    nekoton: undefined,
    fetch: undefined,
    debugLog: undefined,
};
exports.default = core;
